import dayjs from "dayjs";

export const getCurrentDateTimeUTC = () => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, "0");
  const day = String(now.getUTCDate()).padStart(2, "0");
  const hours = String(now.getUTCHours()).padStart(2, "0");
  const minutes = String(now.getUTCMinutes()).padStart(2, "0");
  const seconds = String(now.getUTCSeconds()).padStart(2, "0");
  const formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}`;
  return formattedDateTime;
};

export const DATE_TIME_FORMATS = {
  MMM_DD_YYYY_hh_mm_A: "MMM DD, YYYY hh:mm A",
};

export const formatDateTime = (date, format = DATE_TIME_FORMATS.MMM_DD_YYYY_hh_mm_A) => {
  if (!date) return "";
  return dayjs(date).format(format);
};
